export const listingBookingSettings = {
  section01: {
    title: "Direct bookings for this listing",
  },
  motor: {
    activeTitle: "Booking engine active",
    inactiveTitle: "Booking engine inactive",
    activeDesc: "Guests can book this listing directly from its link.",
    inactiveDesc: "Direct bookings are turned off for this listing.",
    statusOn: "Active",
    statusOff: "Inactive",
  },
  payment: {
    title: "When does the guest pay?",
    onArrival: {
      name: "Pay on arrival",
      hint: "Book free, pay when you arrive.",
    },
    online: {
      name: "Pay online",
      hint: "Pay when the booking is confirmed.",
    },
  },
  common: {
    saving: "Saving…",
    onlyOnlineBadge: "Online payment only",
  },
  hold: {
    title: "Hold time",
    desc: "The calendar is blocked while the guest completes payment.<br>If they don't pay within the set time, <strong>availability is released automatically</strong>.",
  },
  units: {
    min: "min",
    hour: "hour",
    hours: "hours",
  },
  partial: {
    title: "Partial payment",
    cardTitle: "Allow paying only part at booking",
    descOn: "<strong>Enabled.</strong> The guest can pay <strong>{percent}%</strong> now and the rest before arrival (or pay in full).",
    descOff: "<strong>Disabled.</strong> The guest pays the <strong>full amount</strong> at booking.",
    blockTitle: "The rest is paid at the accommodation",
    blockOn: "<strong>Enabled.</strong> The guest pays <strong>only {percent}%</strong> online; the rest is paid <strong>on arrival</strong> (they can't pay in full online).",
    blockOff: "<strong>Disabled.</strong> The guest can choose to pay {percent}% or the full amount online.",
  },
  reminder: {
    title: "Balance reminder",
    cardTitle: "Send a reminder to pay the outstanding balance",
    daysBefore: "{count} day before | {count} days before",
    descOn: "<strong>Enabled.</strong> <strong>{daysBefore}</strong> arrival (around 09:00, property time) the guest is sent a link to pay the outstanding balance by <strong>WhatsApp and email</strong>.",
    descOff: "<strong>Disabled.</strong> The guest receives no reminder to pay the balance online before arrival.",
    daysLabel: "Days before arrival",
    hint: "Sent only once, and only to guests with an outstanding balance. If the rest is paid at the accommodation, it isn't sent.",
  },
  approve: {
    title: "Approve bookings",
    cardTitle: "Approve each booking before confirming it",
    descOn: "<strong>Enabled.</strong> Every booking stays <strong>pending your approval</strong>: you get a notification and decide whether to accept or reject it. It isn't confirmed until you approve it.",
    descOff: "<strong>Disabled.</strong> Bookings are <strong>confirmed automatically</strong> once payment is completed. Turn it on if you'd rather review and approve each request yourself.",
  },
  toasts: {
    statusUpdatedAll: "Status updated on all units.",
    statusUpdated: "Status updated.",
    statusError: "Couldn't update.",
    paymentUpdated: "Payment method updated.",
    paymentError: "Couldn't save the payment method.",
    partialUpdated: "Partial payment updated.",
    partialError: "Couldn't save the partial payment.",
    reminderUpdated: "Reminder updated.",
    reminderError: "Couldn't save the reminder.",
    saved: "Saved.",
    saveError: "Couldn't save.",
    linkCopied: "Link copied.",
    copyError: "Couldn't copy.",
  },
  share: {
    whatsappText: "Hi 👋 Here's the link to book: {link}",
  },
};
